import CryptoJS from 'crypto-js';
export function splitFilesBySize(
  files: { file_name: string; file_content: string }[],
  maxSize = 400
) {
  const result: any = [];

  files.forEach((file) => {
    const { file_name, file_content } = file;
    let start = 0;
    let currentSize = 0;

    while (start < file_content.length) {
      let end = start;
      currentSize = 0;

      // 计算从 start 到 end 的字节长度
      while (
        end < file_content.length &&
        currentSize + getByteLength(file_content[end]) <= maxSize
      ) {
        currentSize += getByteLength(file_content[end]);
        end++;
      }

      const contentPart = file_content.slice(start, end);
      result.push({
        file_name: `${file_name}`,
        file_content: contentPart,
        id: Math.floor(start / maxSize) + 1,
      });

      start = end;
    }
  });

  return result;
}
// 
export function splitFilesByArrayBufferSize(
  files: { file_name: string; file_content: ArrayBuffer }[],
  maxSize = 400
) {
  const result: any = [];

  files.forEach((file) => {
    const { file_name, file_content } = file;
    let start = 0;

    while (start < file_content.byteLength) {
      const end = Math.min(start + maxSize, file_content.byteLength);
      const contentPart = file_content.slice(start, end);
      result.push({
        file_name: `${file_name}`,
        file_content: contentPart,
        id: Math.floor(start / maxSize) + 1,
      });

      start = end;
    }
  });

  return result;
}

// 辅助函数，计算单个字符的字节长度
export function getByteLength(char: string): number {
  const code = char.charCodeAt(0);
  if (code <= 0x7f) return 1;
  else if (code <= 0x7ff) return 2;
  else if (code <= 0xffff) return 3;
  else if (code <= 0x1fffff) return 4;
  return 1; // 默认返回 1，虽然这种情况不应该发生
}
// 计算文本字节长度
export function getTextByteLength(text: string): number {
  let length = 0;
  for (let i = 0; i < text.length; i++) {
    length += getByteLength(text[i]);
  }
  return length;
}

// 示例用法
// const files = [
//   { file_name: "file1.txt", file_content: "A".repeat(800) },
//   { file_name: "file2.txt", file_content: "B".repeat(600) },
// ];

// const splitFiles = splitFilesBySize(files, 400);
// console.log(splitFiles);


function arrayBufferToWordArray(buffer: ArrayBuffer): CryptoJS.lib.WordArray {
  const uint8Array = new Uint8Array(buffer);
  const words: number[] = [];
  for (let i = 0; i < uint8Array.length; i += 4) {
    words.push(
      (uint8Array[i] << 24) |
      (uint8Array[i + 1] << 16) |
      (uint8Array[i + 2] << 8) |
      uint8Array[i + 3]
    );
  }
  return CryptoJS.lib.WordArray.create(words, uint8Array.length);
}
export function md5ArrayBuffer(buffer: ArrayBuffer): string {
  const wordArray = arrayBufferToWordArray(buffer);
  const hash = CryptoJS.MD5(wordArray);
  return hash.toString(CryptoJS.enc.Hex);
}

export function arrayBufferToBase64(buffer: ArrayBuffer): string {
  const uint8Array = new Uint8Array(buffer);
  return btoa(String.fromCharCode(...uint8Array));
}

(window as any).arrayBufferToBase64 = arrayBufferToBase64;

//  base64 转 arrayBuffer
export function base64ToArrayBuffer(base64: string): ArrayBuffer {
  const binaryString = atob(base64);
  const bytes = new Uint8Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes.buffer;
}

(window as any).base64ToArrayBuffer = base64ToArrayBuffer;

// // 验证
// const base64 = arrayBufferToBase64(new Uint8Array([1, 2, 3, 4]).buffer);
// console.log(base64);
// const buffer = base64ToArrayBuffer(base64);
// console.log(buffer);
